















import Vue from "vue";
import Component from "vue-class-component";

const HomeServiceItemProps = Vue.extend({
  props: {
    icon: {
      type: String,
      required: false,
    },

    image: {
      type: String,
      required: false,
    },

    svg: {
      type: String,
      required: false,
    },

    title: {
      type: String,
      required: true,
    },

    description: {
      type: String,
      required: true,
    },
  },
});

@Component({
  name: "HomeServiceItem",
})
export default class HomeServiceItem extends HomeServiceItemProps {
  cx_icon = this.icon;
  cx_image = this.image;
  cx_svg = this.svg;
  cx_title = this.title;
  cx_description = this.description;

  cx_svgImageStyle = {};

  constructor() {
    super();

    this.cx_icon = "";
    this.cx_image = "";
    this.cx_svg = "";
    this.cx_title = "";
    this.cx_description = "";

    this.cx_svgImageStyle = {};
  }

  mounted(): void {
    this.cx_icon = this.icon;
    this.cx_image = this.image;
    this.cx_svg = this.svg;
    this.cx_title = this.title;
    this.cx_description = this.description;

    this.cx_svgImageStyle = {
      backgroundImage: `url('${this.cx_svg}')`,
    };
  }
}
